import React from 'react'
import { trackActivity } from '../../services/analytics'
import Toolbar from '@material-ui/core/Toolbar'
import AppBar from '@material-ui/core/AppBar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import MenuIcon from '@material-ui/icons/Menu'
import logoImage from '../../icons/svgs_bar/logo.svg'
import classNames from 'classnames'
import NotificationButton from './NotificationButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Sparkles from '../../icons/Sparkles'
import BetaTag from '../../components/BetaTag'

const styles = theme => ({
  appBar: {
    backgroundColor: '#002d72',
    zIndex: theme.zIndex.drawer + 1,
    '@media only print': {
      display: 'none'
    }
  },
  menuButton: {
    margin: '0 8px'
  },
  logo: {
    display: 'block',
    height: 35,
    maxWidth: '100%',
    '@media (max-width: 600px)': {
      width: 100,
      height: 'auto',
    },
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 0
  },
  logoTitle: {
    minWidth: 0
  },
  toolBarRight: {
    margin: '0 8px 0 auto',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  aiButton: {
    color: 'inherit',
    borderColor: 'rgba(255,255,255,0.3)',
    backgroundColor: 'rgba(255,255,255,0.15)',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.25)',
    },
    fontSize: 14,
    fontWeight: 500,
    padding: '6px 16px',
    marginRight: 4,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    borderRadius: '9999px',
    lineHeight: 1,
    '@media (max-width: 600px)': {
      minWidth: 36,
      padding: '8px 10px',
    },
  },
  aiButtonLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  aiButtonBeta: {
    '@media (max-width: 600px)': {
      display: 'none',
    },
  }
})

class AppBarLayout extends React.PureComponent {
  render() {
    const { classes, handleMenuOpen, handleDrawerMessageOpen, onAIAssistantOpen } = this.props
    return (
      <AppBar position="absolute" className={classNames(classes.appBar)}>
        <Toolbar disableGutters={true} className={'container'}>
          <IconButton
            color="inherit"
            aria-label="Abrir menu"
            onClick={handleMenuOpen}
            className={classNames(classes.menuButton)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="title" color="inherit" noWrap className={classes.logoTitle}>
            <div className={classes.logoContainer}>
              <img src={logoImage} className={classes.logo} alt="Informed" />
            </div>
          </Typography>
          <div className={classes.toolBarRight}>
            {onAIAssistantOpen && (
              <Button
                id="ai-assistant-header-btn"
                variant="outlined"
                className={classes.aiButton}
                classes={{ label: classes.aiButtonLabel }}
                onClick={() => { trackActivity('click', true); onAIAssistantOpen() }}
                aria-label="Abrir Informed IA"
              >
                <Sparkles width={16} height={16} />
                <span>Informed IA</span>
                <span className={classes.aiButtonBeta}>
                  <BetaTag
                    bg="rgba(255,255,255,0.2)"
                    color="#ffffff"
                    borderColor="rgba(255,255,255,0.5)"
                  />
                </span>
              </Button>
            )}
            <NotificationButton
              color="inherit"
              aria-label="Abrir Notificações"
              onClick={handleDrawerMessageOpen}
            />
          </div>
        </Toolbar>
      </AppBar>
    )
  }
}

export default withStyles(styles, { withTheme: true })(AppBarLayout)
